import type {Schemas} from 'api/dto.generated';
import type {ViewMode} from '../types';

export const mapViewMode = (
  viewmode?: ViewMode,
): Schemas.ExportRequest['type'] => {
  if (viewmode === 'work') {
    return 'WORK';
  }

  // Api also defaults to MANIFESTATION
  return 'MANIFESTATION';
};
